import type { SongsBrewStatus } from './useSongsBrewState';

/**
 * The states of the Home card (design: songsbrew-promotion a2-a6; `SbCard` prop `state`):
 * offer, busy (the call runs), error (the call threw), done, refused, unsubscribed (the address left
 * SongsBrew before and the platform cannot add it again).
 */
export type SongsBrewCardPhase = 'offer' | 'busy' | 'error' | 'done' | 'refused' | 'unsubscribed';

/** The phase on load: `refused` shows the refused text, every other status the offer. */
export function cardPhaseOfStatus(status: SongsBrewStatus): SongsBrewCardPhase {
  return status === 'refused' ? 'refused' : 'offer';
}

/** The phase after `newsletter.subscribe`. Only `subscribed` is "You're in". */
export function cardPhaseOfAnswer(status: 'subscribed' | 'unsubscribed' | 'refused'): SongsBrewCardPhase {
  switch (status) {
    case 'subscribed':
      return 'done';
    case 'refused':
      return 'refused';
    case 'unsubscribed':
      return 'unsubscribed';
  }
}

/** The offer, the busy and the error phases show the pitch text, the column and the button. */
export function isPitchPhase(phase: SongsBrewCardPhase): boolean {
  return phase === 'offer' || phase === 'busy' || phase === 'error';
}
